import { usePublicConfig } from '@/hooks/queries/usePublicConfig';

export const DEFAULT_SITE_NAME = 'GoLoka';

/** Return the configured public site name with a stable display fallback. */
export function useSiteName(): string {
  const { data } = usePublicConfig('site.name');
  return data?.config_value?.trim() || DEFAULT_SITE_NAME;
}
